package com.milta.core.localization.translations.ro

import com.milta.core.localization.OptimizationQuotaStrings

internal val OptimizationQuota = OptimizationQuotaStrings(
    exhaustedTitle = "Cota de optimizări atinsă",
    exhaustedCreateRouteMessage = "Din nou disponibil pe {date}. Puteți crea traseul fără optimizare: ordinea introdusă se păstrează.",
    exhaustedCreateBatchMessage = "Din nou {limit} optimizări pe {date}. Lotul poate fi creat fără optimizare: ordinea introdusă se păstrează.",
    quotaReachedResetOn = "Cota de optimizări atinsă — resetare pe {date}",
    routeCreatedInEnteredOrder = "Traseu creat în ordinea introdusă.",
    routeWillBeCreatedInEnteredOrder = "Traseul va fi creat în ordinea introdusă.",
    batchCreatedInEnteredOrder = "Lotul a fost creat fără optimizare, în ordinea introdusă.",
    sendWithoutOptimization = "Trimite fără optimizare",
    batchNotOptimizedTitle = "Lot creat fără optimizare",
    batchNotOptimizedMessage = "Cota de optimizări atinsă. Ordinea actuală a opririlor se păstrează.",
    batchNotOptimizedMobileMessage = "Lot creat fără optimizare: cota de optimizări atinsă. Ordinea introdusă păstrată, opriri împărțite egal.",
    reoptimizeAction = "Reoptimizează",
    reoptimizeUnavailableWeb = "Reoptimizare indisponibilă: cotă atinsă, din nou pe {date}. Ordinea actuală se păstrează și trimiterea rămâne posibilă.",
    reoptimizeUnavailableMobile = "Reoptimizare indisponibilă până pe {date} (cotă atinsă). Trimiterea rămâne posibilă.",
    stopAddedAtEndTitle = "Oprire adăugată la sfârșitul traseului",
    stopAddedAtEndMessage = "Cota de optimizări atinsă — resetare pe {date}. Ordinea celorlalte opriri nu se schimbă.",
    reoptimizeExhaustedHint = "Cota de optimizări atinsă, din nou pe {date}",
    myOptimizationsTitle = "Optimizările mele",
    remainingForPeriod = "Rămas pentru perioadă",
    remainingSuffix = "rămase",
    resetLabel = "Resetare",
    resetAtRenewal = "La reînnoirea abonamentului",
    driverExplanation = "Se resetează la reînnoirea abonamentului. Șofer al unei Întreprinderi: contorul urmează abonamentul Întreprinderii, cu limita de probă cât timp aceasta este în probă.",
    enterpriseExplanation = "Se resetează la reînnoirea abonamentului. Acest contor privește doar optimizările dvs.; fiecare șofer are propriul contor.",
    webCounterNotice = "Acest contor privește doar optimizările lansate de acest cont. Fiecare șofer are propriul contor, vizibil în aplicația sa.",
    historyTitle = "Istoric",
    columnDate = "Dată",
    columnAction = "Acțiune",
    columnTarget = "Traseu vizat",
    columnOutcome = "Rezultat",
    actionOptimizeRoute = "Optimizare traseu",
    actionCreateRouteBatch = "Creare lot",
    actionReoptimizeRouteBatch = "Reoptimizare lot",
    actionReoptimizeOnStopAdded = "Reoptimizare la adăugarea unei opriri",
    actionReoptimizeInPlace = "Reoptimizare pe traseu",
    actionCreateOwnRoute = "Creare traseul meu",
    outcomeCounted = "Numărată",
    outcomeRefunded = "Restituită",
    outcomeRefundedLong = "Restituită — eroare RoutaR",
    refundedNotCounted = "eroare RoutaR, nenumărată",
    targetRoute = "Traseul din {date}",
    targetBatch = "Lotul din {date}",
    historyLoadingMore = "Se încarcă rândurile următoare…",
    historyEnd = "Sfârșitul istoricului — {count} rânduri",
    historyEmpty = "Nicio optimizare în această perioadă.",
    historyLoadError = "Istoricul nu a putut fi încărcat.",
    retryAction = "Reîncearcă",
    loading = "Se încarcă…",
    errorNoConnection = "Serverul nu poate fi contactat — verificați conexiunea.",
    errorGeneric = "A apărut o eroare. Reîncercați mai târziu.",
    tabOptimizations = "Optimizări RoutaR",
    tabAiTokens = "Tokenuri IA",
    comingSoon = "În curând",
    limitsDescription = "Numărul de optimizări RoutaR permise pe cont și pe perioadă de abonament, în funcție de tipul contului și de starea abonamentului. Contorul fiecărui cont se resetează la reînnoirea abonamentului său.",
    columnTrial = "Probă",
    columnPaid = "Plătit",
    rowEnterprise = "Cont Întreprindere",
    rowDriver = "Șofer",
    fieldRequired = "Câmp obligatoriu.",
    fieldMustBePositive = "Trebuie să fie mai mare decât 0.",
    limitsFootnote = "Valori exprimate în optimizări pe perioadă. Un șofer al unei Întreprinderi primește limita „Șofer”, de probă cât timp Întreprinderea sa este în probă, altfel plătită.",
    limitsSaved = "Limite salvate. Întreprindere: {enterpriseTrial} probă · {enterprisePaid} plătit. Șofer: {driverTrial} probă · {driverPaid} plătit.",
    limitsRejected = "Valori respinse: fiecare limită trebuie să fie mai mare decât 0.",
    saveAction = "Salvează",
    detailsAction = "Detalii",
    accountDetailsTitle = "Detaliile utilizatorului",
    sectionIdentity = "Identitate",
    accountTypeLabel = "Tip de cont",
    kindEnterpriseOwner = "Cont Întreprindere",
    kindEnterpriseDriver = "Șofer al Întreprinderii",
    kindIndependentDriver = "Șofer independent",
    withoutOrganisation = "Fără organizație",
    subscriptionLabel = "Abonament",
    viaOrganisation = "Prin organizație",
    subscriptionTrial = "Probă",
    subscriptionPaid = "Plătit",
    appliedLimitLabel = "Limită aplicată",
    limitKindEnterprise = "Limită Cont Întreprindere",
    limitKindDriver = "Limită Șofer",
    enterpriseInTrialSuffix = "(Întreprinderea este în probă)",
    resetSourceOwn = "Reînnoirea abonamentului",
    resetSourceEnterprise = "Reînnoirea {enterprise}",
    exhaustedBadge = "Cotă epuizată",
    manuallyAdjustedBadge = "Înlocuit manual",
    replaceLabel = "Înlocuiește numărul rămas",
    replaceAction = "Înlocuiește",
    replaceHelp = "Doar pentru perioada curentă. La resetare, contul pornește din nou de la limita globală.",
    replaceHelpEnterpriseDriver = "Modifică doar contorul lui {name}. Cel al Întreprinderii și al celorlalți șoferi nu se schimbă.",
    replaceInvalid = "Introduceți un număr mai mare sau egal cu 0.",
    replaceRejected = "Valoare respinsă de server.",
    replaceMaximum = "Maximum 100.000.",
    replacedBanner = "Număr rămas înlocuit: {from} → {to}. Pentru perioada curentă. Pe {date}, revenire la limita globală ({limit}).",
    adminHistoryTitle = "Istoricul optimizărilor",
    accountNotFound = "Cont negăsit.",
)
